import React from 'react';
import './Loading.css';

export default function Loading(props) {
  return (<div className="loading">
    <div className="signal"></div>
    {props.children}
  </div>);
};



// WEBPACK FOOTER //
// ./src/Util/Loading.js